<template>
    <div>
        <v-form ref="form" v-model="valid">
            <!-- Seção: Identificação -->
            <div class="section-title mb-2">
                <v-icon color="primary" class="mr-2">mdi-identifier</v-icon>
                <span class="text-subtitle-1 font-weight-bold primary--text">Identificação</span>
            </div>
            <v-divider class="mb-4" />
            <v-row dense>
                <v-col cols="12" sm="2" md="2">
                    <v-text-field
                        outlined
                        dense
                        label="ID"
                        v-model="cartorio.id"
                        readonly
                        disabled
                        prepend-inner-icon="mdi-key"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-text-field
                        outlined
                        dense
                        label="Código IBGE"
                        v-model="cartorio.cd_ibge_comarca"
                        readonly
                        disabled
                        prepend-inner-icon="mdi-map-marker"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-text-field
                        outlined
                        dense
                        label="Número"
                        v-model="cartorio.nu_cartorio"
                        readonly
                        disabled
                        prepend-inner-icon="mdi-numeric"
                    />
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <v-text-field
                        outlined
                        dense
                        label="CNPJ"
                        v-model="cartorio.cnpj"
                        :rules="[rules.required, rules.validarCNPJ]"
                        v-mask="'XX.XXX.XXX/XXXX-##'"
                        prepend-inner-icon="mdi-file-document"
                    />
                </v-col>
                <v-col cols="12" sm="8" md="8">
                    <v-text-field
                        outlined
                        dense
                        label="Nome do Cartório"
                        v-model="cartorio.nm_cartorio"
                        :rules="requiredRules"
                        prepend-inner-icon="mdi-office-building"
                    />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field
                        outlined
                        dense
                        label="Responsável pelo Tabelionato"
                        v-model="cartorio.nm_responsavel_tabelionato"
                        prepend-inner-icon="mdi-account"
                    />
                </v-col>
            </v-row>

            <!-- Seção: Contato -->
            <div class="section-title mb-2 mt-4">
                <v-icon color="primary" class="mr-2">mdi-phone</v-icon>
                <span class="text-subtitle-1 font-weight-bold primary--text">Contato</span>
            </div>
            <v-divider class="mb-4" />
            <v-row dense>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field
                        outlined
                        dense
                        label="Telefone"
                        v-model="cartorio.telefone"
                        :rules="requiredRules"
                        prepend-inner-icon="mdi-phone"
                    />
                </v-col>
                <v-col cols="12" sm="8" md="8">
                    <v-text-field
                        outlined
                        dense
                        label="E-mail"
                        v-model="cartorio.email"
                        :rules="[rules.required, rules.email]"
                        prepend-inner-icon="mdi-email"
                    />
                </v-col>
            </v-row>

            <!-- Seção: Endereço -->
            <div class="section-title mb-2 mt-4">
                <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
                <span class="text-subtitle-1 font-weight-bold primary--text">Endereço</span>
            </div>
            <v-divider class="mb-4" />
            <v-row dense>
                <v-col cols="12" sm="2" md="2">
                    <v-text-field
                        outlined
                        dense
                        label="CEP"
                        v-model="cartorio.cep"
                        :rules="requiredRules"
                        prepend-inner-icon="mdi-mailbox"
                    />
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <v-text-field
                        outlined
                        dense
                        label="Endereço"
                        v-model="cartorio.endereco"
                        :rules="requiredRules"
                        prepend-inner-icon="mdi-road"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-text-field
                        outlined
                        dense
                        label="Número"
                        v-model="cartorio.endereco_numero"
                        :rules="requiredRules"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-text-field
                        outlined
                        dense
                        label="Complemento"
                        v-model="cartorio.complemento"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-text-field
                        outlined
                        dense
                        label="Bairro"
                        v-model="cartorio.bairro"
                        :rules="requiredRules"
                        prepend-inner-icon="mdi-home-city"
                    />
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <v-text-field
                        outlined
                        dense
                        label="Cidade"
                        v-model="cartorio.nm_cidade"
                        :rules="requiredRules"
                        prepend-inner-icon="mdi-city"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-select
                        outlined
                        dense
                        label="UF"
                        v-model="cartorio.cd_uf"
                        :rules="requiredRules"
                        :items="listaUfs"
                        prepend-inner-icon="mdi-flag"
                    />
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import { eventFecharModal } from '../helpers/Utilitarios';
import { OnRules } from 'vuetify-js-utils';
import { validarCNPJ } from '../helpers/Utilitarios';

export default {
    mixins: [OnRules],
    name: 'DetalheCartorio',
    props: {
        cartorio: {
            type: Object,
            required: false
        },
        validarForm: {
            type: Boolean,
            required: false
        },
        showActionSalvar: Boolean
    },
    data() {
        return {
            rules: {
                required: value => !!value || 'Campo obrigatório',
                validarCNPJ: value => {
                    if (!value) return true;
                    const stripped = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
                    if (stripped.length !== 14) return 'CNPJ inválido';
                    if (!/^[A-Z0-9]{12}\d{2}$/.test(stripped)) return 'CNPJ inválido';
                    return true;
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || 'E-mail inválido';
                }
            },
            requiredRules: [v => !!v || 'Campo Obrigatório'],
            valid: false,
            listaUfs: [
                'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
                'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
                'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
            ]
        };
    },
    methods: {
        validarCNPJ,
        eventFecharModal,
        submit() {}
    },
    watch: {
        'cartorio.cnpj'(val) {
            if (val) {
                const upper = val.toUpperCase();
                if (upper !== val) this.cartorio.cnpj = upper;
            }
        },
        validarForm(val) {
            if (val) {
                this.$refs.form.validate();
                this.$emit('formValidado', false);
            }
        },
        valid(val) {
            this.$emit('setIsInvalid', !val);
        }
    },
    beforeDestroy() {
        document.removeEventListener('keyup', this.eventFecharModal);
    },
    mounted() {
        document.addEventListener('keyup', this.eventFecharModal);
    }
};
</script>

<style scoped>
.section-title {
    display: flex;
    align-items: center;
}
</style>
